import { DEFAULT_CART_FONT_SIZE_TEXT_IN_PX } from '@styles/constants';

import { IPriceModel, ISeparatorModel } from './model';

export const DEFAULT_CURRENCY_SETUP: IPriceModel = {
  priceSize: DEFAULT_CART_FONT_SIZE_TEXT_IN_PX,
  currencySize: DEFAULT_CART_FONT_SIZE_TEXT_IN_PX,
  bold: false,
};

export const DEFAULT_SEPARATOR_SETUP: ISeparatorModel = {
  separatorSize: DEFAULT_CART_FONT_SIZE_TEXT_IN_PX,
  bold: false,
};
